import { environment } from 'src/environments/environment';

declare let gtag: (property: string, value: any, configs?: any) => {};

export function triggerEvent(eventName: string, condition: boolean = true) {
  if (environment.production && condition) {
    gtag('config', environment.googleAnalyticsId);
    gtag('event', eventName);
  }
}

export enum AnalyticsEvent {
  browseTitlesComplete = 'browse_titles_complete',
  browseTitlesFirstInteraction = 'browse_titles_first_interaction',
  browseTitlesFreeplay = 'browse_titles_freeplay',
  browseTitlesMoreInfoClose = 'browse_titles_more_info_close',
  browseTitlesMoreInfoOpen = 'browse_titles_more_info_open',
  browseTitlesPage = 'ham_nav_browse_titles_live_tv',
  compareBottom = 'compare_page_scroll',
  compareClose = 'compare_page_close',
  compareEndScreen = 'recap_screen_compare',
  compareNav = 'ham_nav_compare',
  compareOpen = 'ham_nav_compare',
  compareVoiceSearch = 'end_screen_compare',
  compareIntro = 'intro_screen_compare',
  interactClick = 'start_page_interact',
  menuClosed = 'ham_nav_close',
  menuOpen = 'ham_nav_open',
  recapBrowseTitles = 'recap_screen_browse_titles_live_tv',
  recapCompare = 'recap_screen_compare',
  recapRecommendations = 'recap_screen_entertainment_recs',
  recapVoice = 'recap_screen_voice_search',
  recapWatchlist = 'recap_screen_watchlist',
  recommendationsComplete = 'entertainment_recs_complete',
  recommendationsFirstInteraction = 'entertainment_recs_first_interaction',
  recommendationsMoreInfoClose = 'entertainment_recs_more_info_close',
  recommendationsMoreInfoOpen = 'entertainment_recs_more_info',
  recommendationsPage = 'ham_nav_entertainment_recs',
  voiceActionMovies = 'voice_search_action_movies',
  voiceChildrens = 'voice_search_childrens_shows',
  voiceDimLights = 'voice_search_dim_lights',
  voiceFirstInteraction = 'voice_search_assistant_button',
  voiceFrontDoor = 'voice_search_front_door',
  voiceMoreInfoClose = 'voice_search_more_info_close',
  voiceMoreInfoOpen = 'voice_search_more_info',
  voicePage = 'ham_nav_voice_search',
  voiceSearchEndScreenOpen = 'end_screen_arrival',
  voiceSearchEndScreenSaySomethingElse = 'end_screen_say_something_else',
  watchlistComplete = 'watchlist_complete',
  watchlistFirstInteraction = 'watchlist_first_interaction',
  watchlistMoreInfoClose = 'watchlist_more_info_close',
  watchlistMoreInfoOpen = 'watchlist_more_info',
  watchlistPage = 'ham_nav_watchlist',
}
